export const DPI_MAX_BYTES = 20_000_000;
export const DPI_MAX_PIXELS = 16_000_000;
export const DPI_MULTIPART_BYTES = 3_000_000;

/** Replicate p-image-upscale output pricing verified 2026-09-06. */
export function dpiProviderCost(inputPixels: number) {
  if (!Number.isSafeInteger(inputPixels) || inputPixels <= 0 || inputPixels > DPI_MAX_PIXELS) throw new Error('SIZE');
  const outputPixels = inputPixels * 4; // 2x on both axes, no downscaling.
  return outputPixels <= 4_000_000 ? 0.005 : outputPixels <= 8_000_000 ? 0.01 : outputPixels <= 16_000_000 ? 0.02 : outputPixels <= 32_000_000 ? 0.04 : 0.06;
}
